<template>
  <div style="margin-top: 10px">
    <div class="row">
      <div class="col-md-3">
        <label>Prefijo</label>
        <base-input v-model="model.Aux1" @blur="change" :maxlength="4"></base-input>
      </div>
      <div class="col-md-9">
        <label>Numero</label>
        <base-input v-model="model.Aux2" @blur="change" :maxlength="8"></base-input>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <money-with-indicator v-model="model.Importe" v-on:blur="change" v-on:validatedOK="onSaldoOK"/>
      </div>
    </div>
  </div>
</template>

<script>
import { truncate } from "fs";
import MoneyWithIndicator from '@/components/Custom/MoneyWithIndicator';

export default {
  components: {
    "money-with-indicator": MoneyWithIndicator
  },
  props: {
    model: {
      Aux1: "",
      Aux2: "",
      Aux3: "",
      Aux4: "",
      Importe: 0,
      Validate: false,
      Errors: []
    }
  },
  data() {
    return {};
  },
  methods: {
    validate() {
      let context = this;
      context.model.Errors = [];
      if (context.model.Aux1.length == 0) {
        context.model.Validate = false;
        context.model.Errors.push("Debe ingresar el prefijo");
      } else if (context.model.Aux2.length == 0) {
        context.model.Validate = false;
        context.model.Errors.push("Debe ingresar el número");
      } else if (context.model.Aux1.length + context.model.Aux2.length != 10) {
        context.model.Validate = false;
        context.model.Errors.push(
          "El prefijo y el numero deben sumar 10 digitos"
        );
      } else if (context.model.Importe <= 0) {
        context.model.Validate = false;
        context.model.Errors.push("El importe no puede ser menor que 0");
      } else {
        context.model.Validate = true;
      }
    },
    change(element) {
      this.validate();
      this.$emit("input", this.model);
    },
    onSaldoOK(val) {
      this.$emit("saldoOK", val);
    }
  }
};
</script>